import React from 'react';
import PropTypes from 'prop-types';
import PlacesAutocomplete, {
  geocodeByAddress /* geocodeByPlaceId */,
} from 'react-places-autocomplete';
import TextField from '../Forms/TextField';
import { getMyAdress } from '../../helpers/utils';

const GooglePlacesAutocomplete = (props) => {
  const { error: hasError } = props;
  const [address, setAddress] = React.useState(props.address || '');
  const [error, setError] = React.useState('');
  const { setAddressSelected } = props;
  const handleSelect = async (value) => {
    geocodeByAddress(value)
      .then((result) => {
        const aux = getMyAdress(result, value);
        let score = 0;
        Object.keys(aux).forEach((elm) => {
          // eslint-disable-next-line default-case
          switch (elm) {
            case 'administrative_area_level_1':
              score++;
              break;
            case 'administrative_area_level_2':
              score++;
              break;
            case 'administrative_area_level_3':
              score++;
              break;
          }
        });
        if (score < 3) {
          setError('Verifica que la dirección ingresada se encuentre completa');
          props.setAddressError(true);
        } else {
          setError('');
          props.setAddressError(false);
        }
        setAddressSelected(getMyAdress(result, value));
      })
      .catch((error) => console.error('Error', error));

    setAddress(value);

    setAddressSelected(value);
    const element = document.getElementById(props.id);
    const event = new Event('input', { bubbles: true });
    element.dispatchEvent(event);

    // setCoordinates(latLng);
  };

  const styleCuadro = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid #eee',
    zIndex: '8',
    marginTop: error.length > 0 || hasError ? '-24px' : '0px',
    // width: "100%"
  };
  const searchOptions = {
    componentRestrictions: { country: props.country },
    types: ['address'],
  };

  return window.google ? (
    <PlacesAutocomplete
      value={address}
      onChange={setAddress}
      onSelect={handleSelect}
      searchOptions={searchOptions}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <TextField
            {...props}
            id={props.id}
            {...props.textFieldProps}
            onChange={props.handleEdit}
            error={error.length !== 0 || props.helperText !== undefined}
            helperText={error || props.helperText}
            {...getInputProps()}
          />
          <div
            className="container-suggestions"
            style={loading || suggestions ? styleCuadro : null}
          >
            {/* loading ? <div>Cargando...</div> : null */}
            {suggestions.map((suggestion) => {
              const style = {
                backgroundColor: suggestion.active ? '#eee' : '#fff',
                textAlign: 'left',
                padding: '10px',
                color: 'black',
              };
              return (
                <div id="div-suggest-styled" {...getSuggestionItemProps(suggestion, { style })}>
                  {suggestion.description}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  ) : (
    <TextField id={props.id} {...props.textFieldProps} onChange={props.handleEdit} />
  );
};
GooglePlacesAutocomplete.prototype = {
  setAddressSelected: PropTypes.func,
  address: PropTypes.string.isRequired,
  textFieldProps: PropTypes.object,
};
export default GooglePlacesAutocomplete;
